import React from 'react';
import {Label} from '@lightricks/react-design-system';
import styles from './BriefTag.module.scss';

interface BriefTagProps {
  label: string;
  prefix?: string;
}

function BriefTag({label, prefix}: BriefTagProps) {
  return (
    <Label size="md" className={styles.tag}>
      {prefix}
      {label}
    </Label>
  );
}

export default BriefTag;
